export default function set_or_update_queryparam(url, key, val) {
  const [basePath, search] = url.split("?", 2);
  const queryParams = new URLSearchParams(search);
  queryParams.set(key, val);
  return `${basePath}?${queryParams.toString()}`;
}
